import { TopMenu } from "../../top-menu/TopMenu";
import { Footer } from "../../footer/Footer";
import Tablet from '../../../assets/Hand_Holds_A_Tablet_original_1095353.jpg';
import { useState } from "react";

export const ContactUs = () => {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    const inputClass = "mt-1 p-2 border border-gray-300 rounded text-base text-black bg-white w-full";

    return (
        <div className="min-h-screen flex flex-col">
            <TopMenu />
            <main className="flex-1 py-10 px-5 grid grid-cols-1 md:grid-cols-2 gap-10">
                <div>
                    <img src={Tablet} alt="Contact" className="w-full md:w-4/5" />
                </div>
                <div className="text-justify">
                    <h1 className="bg-navy text-white pl-2.5 mt-0">Jim Truitt</h1>
                    <h2 className="text-navy">CEO</h2>
                    <p>
                        <strong>Cel:</strong> (858) 344-2140<br />
                        <strong>Emails:</strong><br />
                        <a href="mailto:jim@aircad.net" className="no-underline text-navy font-bold inline-block hover:scale-[1.01] transition-transform">jim@aircad.net</a><br />
                        <a href="mailto:jim@rockypointdetailing.com" className="no-underline text-navy font-bold inline-block hover:scale-[1.01] transition-transform">jim@rockypointdetailing.com</a>
                    </p>
                    <h2 className="text-navy">Contact Us</h2>
                    <form onSubmit={handleSubmit} className="bg-navy text-white p-5 rounded">
                        <label className="flex flex-col font-medium mb-2">
                            Name:
                            <input type="text" name="name" value={formData.name} onChange={handleChange} required className={inputClass} />
                        </label>
                        <label className="flex flex-col font-medium mb-2">
                            Email:
                            <input type="email" name="email" value={formData.email} onChange={handleChange} required className={inputClass} />
                        </label>
                        <label className="flex flex-col font-medium mb-2">
                            Message:
                            <textarea name="message" value={formData.message} onChange={handleChange} required className={`${inputClass} resize-y`} rows={4} />
                        </label>
                        <div className="flex justify-end mt-5">
                            <button
                                type="submit"
                                className="bg-accent text-black px-4 py-1.5 rounded border-none text-base cursor-pointer hover:bg-accent-hover transition-colors duration-200"
                            >
                                Send
                            </button>
                        </div>
                    </form>
                </div>
            </main>
            <Footer />
        </div>
    );
};
